import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginEntity } from 'src/app/interfaces/login';
import { EntidadEmpresarialEntity, ServicioEntidadService } from 'src/app/services/servicio-entidad.service';
import { FiltrosFormatoAsistencialEntity, FormatoAsistencialEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { ServicioParametroSimensService } from 'src/app/services/servicio-parametro-simens.service';

@Component({
  selector: 'app-pregunta-asistencial',
  templateUrl: './pregunta-asistencial.component.html',
  styleUrls: ['./pregunta-asistencial.component.css']
})
export class PreguntaAsistencialComponent implements OnInit {

  canLoad: boolean;
  loading: boolean;
  mensajeError: string;

  filtrosSeleccionados: FiltrosFormatoAsistencialEntity;
  entidad: EntidadEmpresarialEntity;
  datosEncabezado: FormatoAsistencialEntity;
  parametroSimens: any;

  public objetoFiltros: FiltrosFormatoAsistencialEntity = {
    codigoBaseDatos : '',
    archivo : false,
    diligenciados : false,
    evoluciones : false,
    firmaAfiliado : false,
    firmaProfesional : true,
    notas : false,
    solicitudServicios: false,
    marcaAgua : '',
    sede : 0,
    user : '',
    pregunta : 0
  };

  constructor(private activatedRoute: ActivatedRoute,
              private servicioFormato: ServicioFormatoAsistencialService,
              private servicioEntidad: ServicioEntidadService,
              private servicioSimens: ServicioParametroSimensService) {
    this.activatedRoute.params.subscribe(params => {
      this.objetoFiltros.codigoBaseDatos = params['codigoBaseDatos'];
      this.objetoFiltros.uncoLogin = Number(params['uncoLogin']);
      this.objetoFiltros.tta = Number(params['tta']);
      this.objetoFiltros.sede = Number(params['uncoSede']);
      this.objetoFiltros.pregunta = Number(params['pregunta']);

      this.servicioFormato.clearTemporalWait();
      this.getUsuario();
    });
  }

  ngOnInit() { }

  public onFiltrosCompletados(filtros: FiltrosFormatoAsistencialEntity) {
    this.canLoad = filtros.canLoad;
    if (this.canLoad) {
      this.loading = true;
      this.filtrosSeleccionados = filtros;
      this.getHeader();
    } else {

    }
  }

  async getUsuario() {
    try {
      this.loading = true;
      const request = await this.servicioFormato.getInformacionLogin(this.objetoFiltros.codigoBaseDatos, this.objetoFiltros.uncoLogin);
      if (request != null) {
        request.subscribe((login: LoginEntity) => {
          this.objetoFiltros.login = login;
          this.objetoFiltros.user = login.usuario;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error('Error Reporte-formato-asistencial.getUsuario()', err);
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del usuario, reporte caso al administrador`;
        });
      }
    } catch (e) {
      console.error('Catch Reporte-formato-asistencial.getUsuario()', e);
    }
  }

  async getHeader() {
    try {
      const response = await this.servicioFormato.getHeaderFormatoAsistencial(this.filtrosSeleccionados.codigoBaseDatos, this.filtrosSeleccionados.tta);
      if (response != null) {
        response.subscribe((data: FormatoAsistencialEntity) => {
          this.datosEncabezado = data;
          if (data) {
            this.getEntidadEmpresarial();
          } else {
            this.loading = false;
            this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del formato, reporte caso al administrador`;
          }
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error('Error Reporte-formato-asistencial.getHeader()', err);
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del formato, reporte caso al administrador`;
        });
      }
    } catch (e) {
      this.loading = false;
      console.error('Catch getHeader()', e);
      this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del formato, reporte caso al administrador`;
    }
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.filtrosSeleccionados.codigoBaseDatos, this.filtrosSeleccionados.sede);
      if (response != null) {
        response.subscribe((data: any) => {
          if (data) {
            this.entidad = data[0];
            this.filtrosSeleccionados.entidadEmpresarial = this.entidad;
            this.getParametroSimens(this.filtrosSeleccionados.sede);
          } else {
            this.loading = false;
            console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Entidades resueltas nulas ');
            this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
          }
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial()', err);
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
        });
      }
    } catch (e) {
      this.loading = false;
      console.error('Catch getEntidadEmpresarial()', e);
      this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
    }
  }

  async getParametroSimens(sede: number) {
    try {
      const response = await this.servicioSimens.getParametroSimensBySede(this.filtrosSeleccionados.codigoBaseDatos, this.filtrosSeleccionados.sede);
      if (response != null) {
        response.subscribe((data: any) => {
          this.parametroSimens = data;
          this.filtrosSeleccionados.parametroSimens = data;
          this.getLogo();
        }, (err: HttpErrorResponse) => {
          this.parametroSimens = null;
          console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Parametro Simens Nulo ');
          console.error('Error getParametroSimens()', err);
        });
      }
    } catch (e) {
      this.parametroSimens = null;
      console.error('Catch getParametroSimens()', e);
      console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Parametro Simens Nulo ');
    }
  }

  async getLogo() {
    try {
      const response = await this.servicioFormato.getLogoEntidadEmpresarial(this.filtrosSeleccionados.codigoBaseDatos, { idEntidad: this.entidad.unco});
      if (response != null) {
        response.subscribe((data: any) => {
          this.entidad.urlLogo = data.source;
          this.loading = false;
          this.mensajeError = null;
        }, (err: HttpErrorResponse) => {
          console.error('Error getLogo()', err);
          this.entidad.urlLogo = '/assets/img/empty.png';
          this.loading = false;
          this.mensajeError = null;
        });
      }
    } catch (e) {
      console.error('Catch getLogo()', e);
      this.entidad.urlLogo = '/assets/img/empty.png';
      this.loading = false;
      this.mensajeError = null;
    }
  }

}
